<template>
    <a-spin tip="Carregando..." :spinning="spinning">
        <div class="container">
            <a-card>
                <!-- Título / Breadcrumb -->
                <template #title>
                    <a-breadcrumb separator=">">
                        <a-breadcrumb-item>
                            <FileOutlined />
                            <a href="/configurations/users"><span>Usuários</span></a>
                        </a-breadcrumb-item>
                        <a-breadcrumb-item>
                            {{ isEditMode ? 'Editar Usuário' : 'Cadastrar Usuário' }}
                        </a-breadcrumb-item>
                    </a-breadcrumb>
                </template>

                <!-- Form -->
                <a-form layout="vertical" class="form-spaced">
                    <a-row :gutter="[16, 8]">
                        <a-col :span="12">
                            <a-form-item label="Nome">
                                <a-input v-model:value="currentRegister.name" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Email">
                                <a-input v-model:value="currentRegister.email" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <a-row :gutter="[16, 8]">
                        <a-col :span="12">
                            <a-form-item label="CPF">
                                <a-input v-model:value="currentRegister.cpf" v-mask="'###.###.###-##'" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Função">
                                <a-input v-model:value="currentRegister.function" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- Grupos + botões de ação, tudo na MESMA linha -->
                    <a-row :gutter="[16, 8]" align="bottom" v-if="props.id">
                        <a-col :span="12">
                            <a-form-item label="Grupos de Usuário">
                                <div class="inline-group">
                                    <a-select
                                        class="group-select"
                                        v-model:value="currentRegister.usersGroups"
                                        mode="multiple"
                                        placeholder="Selecione opções"
                                        allow-clear
                                    >
                                        <a-select-option
                                            v-for="item in options"
                                            :key="item.value"
                                            :value="item.value"
                                        >
                                            {{ item.label }}
                                        </a-select-option>
                                    </a-select>

                                </div>
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Permissões">
                                <!-- Botão Configurar (somente ícone) -->
                                <a-button
                                    type="primary"
                                    class="icon-btn"
                                    @click="isModalVisible = true"
                                    title="Configurar permissões"
                                    aria-label="Configurar permissões"
                                >
                                    <template #icon>
                                        <i class="fa-solid fa-shield-halved"></i>
                                    </template>
                                </a-button>

                                <!-- Botão Revogar (somente ícone) -->
                                <a-button
                                    type="primary"
                                    danger
                                    class="icon-btn"
                                    :loading="revoking"
                                    @click="confirmRevoke"
                                    title="Revogar permissões"
                                    aria-label="Revogar permissões"
                                >
                                    <template #icon>
                                        <i class="fa-solid fa-ban"></i>
                                    </template>
                                </a-button>

                                <a-button
                                    type="default"
                                    class="icon-btn"
                                    @click="openQgisModal"
                                    title="Configurar usuário do QGIS"
                                    aria-label="Configurar usuário do QGIS"
                                >
                                    <template #icon>
                                        <i class="fa-solid fa-map-location-dot"></i>
                                    </template>
                                </a-button>

                                <span
                                    v-if="qgisConfig.is_created"
                                    class="qgis-created-message"
                                >
                                    Usuário criado para o QGIS
                                </span>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- Caso seja criação (sem ID), ainda mostra o campo de grupos sem os botões -->
                    <a-row :gutter="[16, 8]" v-else>
                        <a-col :span="24">
                            <a-form-item label="Grupos de Usuário">
                                <a-select
                                    v-model:value="currentRegister.usersGroups"
                                    mode="multiple"
                                    placeholder="Selecione opções"
                                    allow-clear
                                >
                                    <a-select-option
                                        v-for="item in options"
                                        :key="item.value"
                                        :value="item.value"
                                    >
                                        {{ item.label }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <a-row :gutter="[16, 8]" v-if="!props.id">
                        <a-col :span="12">
                            <a-form-item label="Senha">
                                <a-input v-model:value="currentRegister.password" type="password" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="Confirmar Senha" :validate-status="passwordMismatch ? 'error' : ''">
                                <a-input v-model:value="passConfirm" type="password" @input="checkPasswords" />
                                <p v-if="passwordMismatch" class="error-text">As senhas não coincidem.</p>
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <!-- Botão salvar centralizado e apenas com ícone -->
                    <a-form-item class="mt-16">
                        <div class="save-center">
                            <a-button
                                type="primary"
                                class="icon-btn"
                                :disabled="isSaveDisabled"
                                @click="save"
                                title="Salvar usuário"
                                aria-label="Salvar usuário"
                            >
                                <template #icon>
                                    <i class="fa-solid fa-floppy-disk"></i>
                                </template>
                            </a-button>
                        </div>
                    </a-form-item>
                </a-form>
            </a-card>
        </div>
    </a-spin>

    <!-- Modal de Permissões (apenas 'open' para evitar warning) -->
    <a-modal
        v-model:open="isModalVisible"
        title="Permissões"
        @ok="handleOk"
        :width="'100vw'"
        ok-text="Fechar"
        :cancel-button-props="{ style: { display: 'none' } }"
    >
        <fieldset class="fieldset">
            <legend>Permissões de Menus</legend>
            <a-row :gutter="16" justify="start">
                <a-col :span="6" v-for="menu of menus" :key="menu.id" class="mb-12">
                    <a-collapse>
                        <a-collapse-panel :header="menu.name" :key="menu.id">
                            <a-checkbox
                                v-model:checked="currentRegister.permission_ids[menu.permission_id]"
                                @change="onParentCheckboxChange(menu)"
                            >
                                Ativar permissão
                            </a-checkbox>

                            <a-table
                                :columns="childColumns"
                                :data-source="menu.childrens"
                                bordered
                                size="small"
                                :pagination="false"
                                class="mt-8"
                            >
                                <template #bodyCell="{ record }">
                                    <a-checkbox
                                        v-model:checked="currentRegister.permission_ids[record.permission_id]"
                                        @change="onChildCheckboxChange(menu, record)"
                                    >
                                        {{ record.name }}
                                    </a-checkbox>
                                </template>
                            </a-table>
                        </a-collapse-panel>
                    </a-collapse>
                </a-col>
            </a-row>
        </fieldset>

        <fieldset class="fieldset">
            <legend>Permissões de Mapas</legend>
            <a-row :gutter="16">
                <a-col :span="12">
                    <a-collapse>
                        <a-collapse-panel header="Camadas">
                            <a-checkbox
                                v-model:checked="allMapsChecked"
                                @change="toggleAllMaps(true, $event.target.checked)"
                            >
                                Marcar Todos
                            </a-checkbox>

                            <a-table
                                :columns="[{ title: 'Camadas', dataIndex: 'description', key: 'description' }]"
                                :data-source="maps"
                                bordered
                                size="small"
                                :pagination="false"
                                class="mt-8"
                            >
                                <template #bodyCell="{ record }">
                                    <a-checkbox
                                        v-model:checked="currentRegister.permission_ids[record.permission_id]"
                                    >
                                        {{ record.name }}
                                    </a-checkbox>
                                </template>
                            </a-table>
                        </a-collapse-panel>
                    </a-collapse>
                </a-col>

                <a-col :span="12">
                    <a-collapse>
                        <a-collapse-panel header="Camadas Temáticas">
                            <a-checkbox
                                v-model:checked="allTematicMapsChecked"
                                @change="toggleAllMaps(false, $event.target.checked)"
                            >
                                Marcar Todos
                            </a-checkbox>

                            <a-table
                                :columns="[{ title: 'Camadas', dataIndex: 'name', key: 'name' }]"
                                :data-source="tematicMaps"
                                bordered
                                size="small"
                                :pagination="false"
                                class="mt-8"
                            >
                                <template #bodyCell="{ record }">
                                    <a-checkbox
                                        v-model:checked="currentRegister.permission_ids[record.permission_id]"
                                    >
                                        {{ record.name }}
                                    </a-checkbox>
                                </template>
                            </a-table>
                        </a-collapse-panel>
                    </a-collapse>
                </a-col>
            </a-row>
        </fieldset>

        <fieldset class="fieldset">
            <legend>Permissões de Funcionalidades Específicas</legend>
            <a-row justify="center">
                <a-col :span="12">
                    <a-collapse>
                        <a-collapse-panel header="Funcionalidades Específicas">
                            <a-table
                                :columns="[{title:'Funcionalidades Específicas', dataIndex:'description', key:'description'}]"
                                :data-source="specificFuncs"
                                :pagination="false"
                                bordered
                                :row-class-name="(record) => (!record.status ? 'row-disabled' : '')"
                            >
                                <template #bodyCell="{ column, record }">
                                    <template v-if="column.key === 'description'">
                                        <div style="display:flex; justify-content:space-between">
                                            <span>{{ record.description }}</span>
                                            <a-switch v-model:checked="currentRegister.permission_ids[record.permission_id]" :disabled="!record.status" />
                                        </div>
                                    </template>
                                </template>
                            </a-table>
                        </a-collapse-panel>
                    </a-collapse>
                </a-col>
            </a-row>
        </fieldset>
    </a-modal>

    <a-modal
        v-model:open="isQgisModalVisible"
        title="Configuração de usuário QGIS"
        :confirm-loading="qgisSaving"
        @ok="saveQgisConfig"
        ok-text="Salvar"
        cancel-text="Cancelar"
        :width="800"
    >
        <a-row :gutter="[16, 8]">
            <a-col :span="12">
                <a-form-item label="Login QGIS">
                    <a-input v-model:value="qgisConfig.qgis_username" placeholder="Ex.: joao_silva" />
                </a-form-item>
            </a-col>
            <a-col :span="12">
                <a-form-item label="Senha QGIS">
                    <a-input-password v-model:value="qgisConfig.qgis_password" placeholder="Defina a senha para o banco" />
                </a-form-item>
            </a-col>
        </a-row>

        <a-divider orientation="left">Permissões por tabela</a-divider>

        <a-form-item label="Tabelas GEO">
            <a-select
                v-model:value="selectedGeoTables"
                mode="multiple"
                show-search
                :filter-option="filterGeoTableOption"
                :options="geoTableOptions"
                placeholder="Selecione uma ou mais tabelas que começam com geo_"
                style="width: 100%"
            />
        </a-form-item>

        <a-table
            :columns="qgisColumns"
            :data-source="qgisConfig.permissions"
            :pagination="false"
            size="small"
            bordered
            row-key="_row_key"
        >
            <template #bodyCell="{ column, record }">
                <template v-if="column.key === 'table_name'">
                    {{ record.table_name }}
                </template>
                <template v-else-if="column.key === 'can_insert'">
                    <a-checkbox v-model:checked="record.can_insert" />
                </template>
                <template v-else-if="column.key === 'can_select'">
                    <a-checkbox v-model:checked="record.can_select" />
                </template>
                <template v-else-if="column.key === 'can_update'">
                    <a-checkbox v-model:checked="record.can_update" />
                </template>
                <template v-else-if="column.key === 'can_delete'">
                    <a-checkbox v-model:checked="record.can_delete" />
                </template>
            </template>
        </a-table>
    </a-modal>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { FileOutlined } from '@ant-design/icons-vue'
import { notification, Modal } from 'ant-design-vue'

const isModalVisible = ref(false)
const handleOk = () => { isModalVisible.value = false }

const options = ref([])
const menus = ref([])
const maps = ref([])
const tematicMaps = ref([])
const specificFuncs = ref([])

const props = defineProps(['id'])
const isEditMode = ref(!!props.id)
const spinning = ref(false)
const passConfirm = ref('')
const passwordMismatch = ref(false)
const activeKey = ref([])
const revoking = ref(false)
const isQgisModalVisible = ref(false)
const qgisSaving = ref(false)
const geoTableOptions = ref([])

const currentRegister = ref({
    id: null,
    name: '',
    email: '',
    cpf: '',
    function: '',
    password: '',
    usersGroups: [],
    permission_ids: [] // dic: { [permission_id]: true|false }
})

const qgisConfig = ref({
    is_created: false,
    qgis_username: '',
    qgis_password: '',
    permissions: [],
})

/** Habilitação do botão salvar */
const isSaveDisabled = computed(() => {
    return !currentRegister.value.name ||
        !currentRegister.value.email ||
        (!currentRegister.value.id && (!currentRegister.value.password || !passConfirm.value)) ||
        passwordMismatch.value
})

const allMapsChecked = computed(() =>
        maps.value.length > 0 && maps.value.every(map =>
            currentRegister.value.permission_ids[map.permission_id]
        )
)
const allTematicMapsChecked = computed(() =>
        tematicMaps.value.length > 0 && tematicMaps.value.every(map =>
            currentRegister.value.permission_ids[map.permission_id]
        )
)

const toggleAllMaps = (isGeneralMap, checked) => {
    const list = isGeneralMap ? maps.value : tematicMaps.value
    list.forEach(map => {
        currentRegister.value.permission_ids[map.permission_id] = checked
    })
}

const childColumns = ref([
    { title: 'Filhos', dataIndex: 'name', key: 'name' }
])

const qgisColumns = ref([
    { title: 'Tabela', dataIndex: 'table_name', key: 'table_name' },
    { title: 'Incluir', dataIndex: 'can_insert', key: 'can_insert', width: 90, align: 'center' },
    { title: 'Ler', dataIndex: 'can_select', key: 'can_select', width: 80, align: 'center' },
    { title: 'Alterar', dataIndex: 'can_update', key: 'can_update', width: 90, align: 'center' },
    { title: 'Excluir', dataIndex: 'can_delete', key: 'can_delete', width: 90, align: 'center' },
])

const getUsersGroups = async () => options.value = (await window.axios.get('/api/configurations/users-groups')).data.data.map(gp => ({value: gp.id, label: gp.name}))
const getMenus = async () =>
    (menus.value = (await window.axios.get('/api/configurations/menus?onlyActives=1')).data.data)

const getMaps = async () => maps.value = (await window.axios.get('/api/maps/layers')).data.data

const getTematicMaps = async () => tematicMaps.value = (await window.axios.get('/api/maps/thematic-layers')).data.data

const getSpecificFunctionalities = async () => specificFuncs.value = (await window.axios.get('/api/configurations/specific-functionalities')).data.data;

const onParentCheckboxChange = (menu) => {
    const isChecked = currentRegister.value.permission_ids[menu.permission_id]
    activeKey.value = isChecked ? [menu.permission_id] : []
    menu.childrens.forEach(child => {
        currentRegister.value.permission_ids[child.permission_id] = isChecked
    })
}

const onChildCheckboxChange = (menu) => {
    const allUnchecked = menu.childrens.every(c =>
        !currentRegister.value.permission_ids[c.permission_id]
    )
    currentRegister.value.permission_ids[menu.permission_id] = !allUnchecked
}

const checkPasswords = () => {
    passwordMismatch.value = currentRegister.value.password !== passConfirm.value
}

const fetchUser = async (id) => {
    const register = (await window.axios.get(`/api/configurations/users/${id}`)).data.data
    currentRegister.value.id = register.id
    currentRegister.value.description = register.description
    currentRegister.value.name = register.name
    currentRegister.value.html = register.html
    currentRegister.value.email = register.email
    currentRegister.value.cpf = register.cpf
    currentRegister.value.function = register.function
    currentRegister.value.admin = register.admin
    currentRegister.value.usersGroups = register.users_groups || []
    currentRegister.value.permission_ids = []
    register.permission_ids.forEach(permission => {
        currentRegister.value.permission_ids[permission] = true
    })
}

const getDefaultQgisUsername = () => {
    const email = currentRegister.value.email || ''
    const localPart = email.includes('@') ? email.split('@')[0] : email
    return localPart.replace(/\./g, '_')
}

const filterGeoTableOption = (input, option) => {
    const label = (option?.label || '').toLowerCase()
    return label.includes(input.toLowerCase())
}

const selectedGeoTables = computed({
    get: () => qgisConfig.value.permissions.map(item => item.table_name),
    set: (tables) => {
        const currentByTable = qgisConfig.value.permissions.reduce((acc, item) => {
            acc[item.table_name] = item
            return acc
        }, {})

        qgisConfig.value.permissions = tables.map((tableName, index) => {
            const existing = currentByTable[tableName]

            return {
                _row_key: existing?._row_key || `${Date.now()}-${index}`,
                table_name: tableName,
                can_insert: existing?.can_insert ?? true,
                can_select: existing?.can_select ?? true,
                can_update: existing?.can_update ?? true,
                can_delete: existing?.can_delete ?? false,
            }
        })
    },
})

const getGeoTablesOptions = async () => {
    const response = await window.axios.get('/api/configurations/users/qgis/geo-tables')
    const data = response?.data?.data || []
    geoTableOptions.value = data.map(item => ({
        value: item.qualified_name,
        label: item.qualified_name,
    }))
}

const loadQgisConfig = async () => {
    if (!currentRegister.value.id) return

    const response = await window.axios.get(`/api/configurations/users/${currentRegister.value.id}/qgis-config`)
    const data = response?.data?.data || {}
    qgisConfig.value = {
        is_created: !!data.is_created,
        qgis_username: data.qgis_username || getDefaultQgisUsername(),
        qgis_password: '',
        permissions: (data.permissions || []).map((item, index) => ({
            _row_key: `${Date.now()}-${index}`,
            table_name: item.table_name || `table_${index + 1}`,
            can_insert: !!item.can_insert,
            can_select: item.can_select === undefined ? true : !!item.can_select,
            can_update: !!item.can_update,
            can_delete: !!item.can_delete,
        })),
    }
}

const openQgisModal = async () => {
    if (!currentRegister.value.id) return

    try {
        qgisSaving.value = true
        if (geoTableOptions.value.length === 0) {
            await getGeoTablesOptions()
        }
        await loadQgisConfig()
        isQgisModalVisible.value = true
    } catch (error) {
        notification.error({
            message: 'Erro',
            description: error?.response?.data?.message || error.message,
        })
    } finally {
        qgisSaving.value = false
    }
}

const saveQgisConfig = async () => {
    if (!currentRegister.value.id) return

    try {
        qgisSaving.value = true
        const payload = {
            qgis_username: qgisConfig.value.qgis_username || getDefaultQgisUsername(),
            qgis_password: qgisConfig.value.qgis_password,
            permissions: qgisConfig.value.permissions.filter(item => !!item.table_name),
        }

        const response = await window.axios.post(`/api/configurations/users/${currentRegister.value.id}/qgis-config`, payload)
        const data = response?.data?.data || {}
        qgisConfig.value.is_created = !!data.is_created
        qgisConfig.value.qgis_password = ''

        notification.success({
            message: 'Sucesso',
            description: response.data?.message || 'Configuração QGIS salva.',
        })
        isQgisModalVisible.value = false
    } catch (error) {
        notification.error({
            message: 'Erro ao salvar QGIS',
            description: error?.response?.data?.message || error.message,
        })
    } finally {
        qgisSaving.value = false
    }
}

const save = async () => {
    currentRegister.value.cpf = currentRegister.value.cpf
        ? currentRegister.value.cpf.replace(/\D/g, '')
        : ''

    let { id, password, ...data } = currentRegister.value
    // lista apenas das permissões marcadas
    data.permission_ids = Object.keys(data.permission_ids).filter(
        key => data.permission_ids[key]
    )

    try {
        spinning.value = true
        if (!id) data.password = password

        const response = id
            ? await window.axios.put(`/api/configurations/users/${id}`, data)
            : await window.axios.post('/api/configurations/users', data)

        notification.success({ message: 'Sucesso', description: response.data.message })

        if (!id) {
            await new Promise(resolve => setTimeout(resolve, 400))
            window.location.href = `${response.data.data.id}/edit`
        }
    } catch (error) {
        notification.error({ message: 'Erro', description: error.message })
    } finally {
        spinning.value = false
    }
}

/** Confirmação + chamada para revogar permissões */
const confirmRevoke = () => {
    if (!currentRegister.value.id) return
    Modal.confirm({
        title: 'Revogar permissões',
        content: 'Tem certeza que deseja revogar TODAS as permissões deste usuário?',
        okText: 'Sim, revogar',
        cancelText: 'Cancelar',
        okButtonProps: { danger: true },
        onOk: () => revokePermissions()
    })
}

const revokePermissions = async () => {
    try {
        revoking.value = true
        const id = currentRegister.value.id
        // Ajuste o endpoint conforme seu backend
        const response = await window.axios.post(`/api/configurations/users/${id}/revoke-permissions`)
        notification.success({
            message: 'Permissões revogadas',
            description: response.data?.message || 'Todas as permissões foram removidas.'
        })
        // Limpa localmente e recarrega
        currentRegister.value.permission_ids = []
        await fetchUser(id)
    } catch (error) {
        notification.error({
            message: 'Erro ao revogar',
            description: error?.response?.data?.message || error.message
        })
    } finally {
        revoking.value = false
    }
}

onMounted(async () => {
    await getUsersGroups()
    await getMenus()
    await getMaps()
    await getTematicMaps()
    await getSpecificFunctionalities()
    await getGeoTablesOptions()

    if (props.id) {
        try {
            spinning.value = true
            await fetchUser(props.id)
            await loadQgisConfig()
        } catch (error) {
            notification.error({ message: 'Erro', description: error.message })
        } finally {
            spinning.value = false
        }
    }
})
</script>

<style scoped>
.container {
    max-width: 960px;
    margin: auto;
}

/* Espaçamento consistente entre form-items */
.form-spaced :deep(.ant-form-item) {
    margin-bottom: 14px;
}

.mt-16 { margin-top: 16px; }
.mb-12 { margin-bottom: 12px; }

/* Linha com select + botões colados */
.inline-group {
    display: flex;
    align-items: center;
    gap: 8px;           /* espaço curto entre select e botões */
}
.group-select {
    flex: 1;            /* select ocupa todo o espaço restante */
}

/* Centraliza botão de salvar (apenas ícone) */
.save-center {
    display: flex;
    justify-content: center;
}

/* Botões só ícone */
.icon-btn {
    width: 44px;
    height: 40px;
    padding: 0;
    margin-right: 10px;
}
.icon-btn :deep(.anticon),
.icon-btn i {
    margin: 0;
}

.qgis-created-message {
    color: #52c41a;
    font-weight: 600;
    margin-left: 6px;
}

/* Modal fieldsets */
.fieldset {
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 16px;
}
.fieldset > legend {
    padding: 0 8px;
    font-weight: 600;
}

/* Ajustes finos de tabela no modal */
:deep(.ant-table) { margin-top: 4px; }
:deep(.ant-collapse-content-box) { padding-top: 10px; }

::v-deep(.row-disabled) {
    background-color: #f5f5f5 !important;
    color: #999 !important;
    opacity: 0.6;
    pointer-events: none;
}
</style>
